import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

function ConfirmEntity({
  notificationDetail,
  setNotificationDetail,
  consigneeDetail,
  setConsigneeDetail,
  buyerDetails,
  supplierDetails,
  consigneeId,
  isConsoliatedBooking,
  buyerOrgDetails,
  buyerEntityDetailsList,
  selectedPlant,
}) {
  const [t] = useTranslation('manageorders');

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {!consigneeId &&
        !isConsoliatedBooking &&
        (buyerEntityDetailsList?.length > 1 ? (
          buyerEntityDetailsList.map((entity) => (
            <div className="confirm-entity-item" key={entity.entityId}>
              <h4 className="title">
                {t(
                  'manageordersscreen.createbookingmenu.confirmentities.buyerdetails'
                )}
              </h4>
              <p className="description">
                {ReactHtmlParser(
                  `${buyerOrgDetails?.orgName || ''}${
                    entity.entityName ? `<br/>${entity.entityName}` : ''
                  }${
                    entity?.entityERPValue?.ERPValue ||
                    buyerOrgDetails?.entityERPValue?.ERPValue ||
                    buyerOrgDetails?.orgERPValue?.ERPValue
                      ? `<br/>${
                          entity?.entityERPValue?.ERPValue ||
                          buyerOrgDetails?.entityERPValue?.ERPValue ||
                          buyerOrgDetails?.orgERPValue?.ERPValue
                        }`
                      : ''
                  }<br/>${
                    entity.entityAddress?.[0]?.addressLine1 ||
                    buyerOrgDetails?.orgAddress ||
                    ''
                  }`
                )}
              </p>
            </div>
          ))
        ) : (
          <div className="confirm-entity-item">
            <h4 className="title">
              {t(
                'manageordersscreen.createbookingmenu.confirmentities.buyerdetails'
              )}
            </h4>
            <p className="description">{ReactHtmlParser(buyerDetails)}</p>
          </div>
        ))}
      {isConsoliatedBooking &&
        buyerEntityDetailsList?.length > 0 &&
        buyerEntityDetailsList.map((entity) => (
          <div className="confirm-entity-item" key={entity.entityId}>
            <h4 className="title">
              {t(
                'manageordersscreen.createbookingmenu.confirmentities.buyerdetails'
              )}
            </h4>
            <p className="description">
              {ReactHtmlParser(
                `${buyerOrgDetails?.orgName || ''}${
                  entity.entityName
                    ? `${buyerOrgDetails?.orgName ? '<br/>' : ''}${
                        entity.entityName
                      }`
                    : ''
                }${
                  entity?.entityERPValue?.ERPValue ||
                  buyerOrgDetails?.entityERPValue?.ERPValue ||
                  buyerOrgDetails?.orgERPValue?.ERPValue
                    ? `<br/>${
                        entity?.entityERPValue?.ERPValue ||
                        buyerOrgDetails?.entityERPValue?.ERPValue ||
                        buyerOrgDetails?.orgERPValue?.ERPValue
                      }`
                    : ''
                }${
                  entity.entityAddress || buyerOrgDetails?.orgAddress
                    ? `<br/>${
                        entity.entityAddress || buyerOrgDetails?.orgAddress
                      }`
                    : ''
                }`
              )}
            </p>
          </div>
        ))}
      {!consigneeId && !isConsoliatedBooking && (
        <div className="confirm-entity-item">
          <h4 className="title">
            {t(
              'manageordersscreen.createbookingmenu.confirmentities.supplierdetails'
            )}
          </h4>
          <p className="description">{ReactHtmlParser(supplierDetails)}</p>
        </div>
      )}
      {selectedPlant?.entityName && (
        <div className="confirm-entity-item">
          <h4 className="title">
            {t(
              'manageordersscreen.createbookingmenu.confirmentities.plantdetails'
            )}
          </h4>
          <p className="description">
            {ReactHtmlParser(
              `${selectedPlant?.entityName}${
                selectedPlant?.ERPIdentifier
                  ? `<br/>${selectedPlant?.ERPIdentifier}`
                  : ''
              }${
                selectedPlant?.entityAddresses?.[0]?.addressLine1
                  ? `<br/>${selectedPlant?.entityAddresses?.[0]?.addressLine1}`
                  : ''
              }`
            )}
          </p>
        </div>
      )}
      <div className="confirm-entity-item">
        <h4 className="title">
          {t(
            'manageordersscreen.createbookingmenu.confirmentities.notifyparty'
          )}
        </h4>
        <textarea
          name="notificationDetail"
          id="notificationDetail"
          rows="4"
          cols="50"
          maxLength="500"
          className="description"
          onChange={(e) => setNotificationDetail(e.target.value)}
        >
          {notificationDetail}
        </textarea>
      </div>
      <div className="confirm-entity-item">
        <h4 className="title">
          {t(
            consigneeId
              ? 'manageordersscreen.createbookingmenu.confirmentities.consigneedetailsparty'
              : 'manageordersscreen.createbookingmenu.confirmentities.consigneedetails'
          )}
        </h4>
        <textarea
          id="consigneeDetail"
          name="consigneeDetail"
          rows="4"
          cols="50"
          maxLength="500"
          className="description"
          onChange={(e) => setConsigneeDetail(e.target.value)}
        >
          {consigneeDetail}
        </textarea>

        {/* <input type="text" className="description" /> */}
      </div>
    </div>
  );
}
ConfirmEntity.propTypes = {
  notificationDetail: PropTypes.string,
  setNotificationDetail: PropTypes.func,
  consigneeDetail: PropTypes.string,
  setConsigneeDetail: PropTypes.func,
  supplierDetails: PropTypes.string,
  buyerDetails: PropTypes.string,
  consigneeId: PropTypes.number,
  isConsoliatedBooking: PropTypes.bool,
  buyerOrgDetails: PropTypes.shape({
    orgName: PropTypes.string,
    orgAddress: PropTypes.string,
    entityERPValue: PropTypes.shape({
      ERPValue: PropTypes.string,
    }),
    orgERPValue: PropTypes.shape({
      ERPValue: PropTypes.string,
    }),
  }),
  buyerEntityDetailsList: PropTypes.arrayOf(PropTypes.shape({})),
  selectedPlant: PropTypes.shape({
    _id: PropTypes.number,
    entityName: PropTypes.string,
    entityType: PropTypes.string,
    ERPIdentifier: PropTypes.string,
    entityAddresses: PropTypes.arrayOf(
      PropTypes.shape({ addressLine1: PropTypes.string })
    ),
  }),
};
ConfirmEntity.defaultProps = {
  notificationDetail: '',
  setNotificationDetail: () => {},
  consigneeDetail: '',
  setConsigneeDetail: () => {},
  supplierDetails: '',
  buyerDetails: '',
  consigneeId: null,
  isConsoliatedBooking: false,
  buyerOrgDetails: null,
  buyerEntityDetailsList: [],
  selectedPlant: null,
};
export default ConfirmEntity;
